export default __webpack_public_path__ + "67c6d3d2401b031a7662b86de2de99e2.jpg";